import React from 'react';
import { ApButtonSecondary } from '@alixpartners/ui-components';

import {
	SectionWrapper,
	SectionHeader,
	Title,
	EditLinkWrapper,
	SectionContent,
} from './styles';

const Section = props => {
	const { title, children, onEdit } = props;

	return (
		<SectionWrapper>
			<SectionHeader>
				<Title>{title}</Title>
				<EditLinkWrapper>
					{onEdit && (
						<ApButtonSecondary onClick={onEdit}>Edit</ApButtonSecondary>
					)}
				</EditLinkWrapper>
			</SectionHeader>
			<SectionContent>{children}</SectionContent>
		</SectionWrapper>
	);
};

export default Section;
